module.exports = __webpack_public_path__ + "static/media/attentionIcon.7c5aa6a5.svg";